import styled from 'styled-components';

const StyledPages = styled.div`
  .contenedor-solitud-tc {
    display: grid;
    max-width: 829px;
    margin: 0 auto;
    padding-right: 12px;
    padding-left: 12px;
    margin-right: auto;
    margin-left: auto;
    gap: 10px;
    grid-template-areas: "menu" "contenido";
  }

  ._-gQdp{
    margin-bottom: 3px;
  }

  ._3MBFe {
    font-size: 0.7rem;
  }

  ._1HjZZ:hover {
    background-color: initial;
  }

  ._2INId:hover {
    background-color: initial;
  }

  ._2INId:active {
    background-color: initial;
  }

  ._1HjZZ:active {
    background-color: initial;
  }

  .Autocomplete-input-wrapper {
    border-radius: 4px;
  }

  .Autocomplete-selector .Autocomplete-list li:hover {
    background-color: #d4d4d4;
  }

  @media (max-width: 425px) {
    ._1-A6A ._2ukvI ._34wSw {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 375px) {
    ._1-A6A ._2ukvI ._34wSw {
      font-size: 1.1rem;
    }
  }

  @media (max-width: 320px) {
    .contenedor-solitud-tc {
      display: inherit;
    }
    ._1-A6A ._2ukvI ._34wSw {
      font-size: 1.1rem;
    }
  }
`;

export default StyledPages;

